<template>
  <div>
    <div class="w-full">
      <vx-card id="usersCard" ref="users" title="Users" v-show="!isUserListHidden">        
        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" v-model="selected" pagination :max-items="pageSize" search :data="users" stripe ref="usersTable" class="vs-con-loading__container" single @selected="handleSelectedUser"> <!-- @sort="handleSort" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <!-- ADD NEW -->
            <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewUser">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
            <div>
              <vs-checkbox v-model="showInactive" color="warning">Show Inactive Users</vs-checkbox>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile Number</vs-th>
            <vs-th>Email</vs-th>
            <vs-th>Modified On</vs-th>
            <vs-th>Modified By</vs-th>
            <!-- <vs-th sort-key="userFirstName">Name</vs-th>
            <vs-th sort-key="mobile">Mobile Number</vs-th>
            <vs-th sort-key="email">Email</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th> -->
          </template>

          <template slot-scope="{data}">
            <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" > -->
            <vs-tr :data="user" :state="user.isActive == false ? 'warning':null" :key="indextr" v-for="(user, indextr) in data" >

              <vs-td>
                {{ user.userFirstName + " " + user.userLastName }}
              </vs-td>

              <vs-td>
                {{ user.mobile }}
              </vs-td>

              <vs-td>
                {{ user.email }}
              </vs-td>

              <vs-td>
                {{ user.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td>
                {{ user.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="userInfoCard" ref="userInfo" title="User Info" v-show="!isInfoHidden">
        <vs-divider class="mb-6 pt-0">General Information</vs-divider>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Email</label>
            <vs-input autocomplete="off" icon-no-border ref="emailInput" @blur="evaluateUser" onClick="this.select();" v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col mb-2 mt-8">
            <vs-checkbox v-model="formData.isActive" color="success">Is Active</vs-checkbox>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>First Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="First Name" icon-pack="feather" icon="icon-user" v-model="formData.userFirstName" />
            <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Last Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Last Name" icon-pack="feather" icon="icon-user" v-model="formData.userLastName" />
            <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Work Phone</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'numeric'" name="Work Phone" icon-pack="feather" icon="icon-phone" v-model="formData.work" />
            <span class="text-danger text-sm" v-show="errors.has('Work Phone')">{{ errors.first('Work Phone') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Mobile</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|numeric'" name="Mobile" icon-pack="feather" icon="icon-smartphone" v-model="formData.mobile" />
            <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Identification Number / Passport Number / Service SETA Number</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full"  name="Identification Number" icon-pack="feather" icon="icon-hash" v-model="formData.idNumber" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2" v-if="allowRegNum">
            <label>Registration Number</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required'" name="Registration Number" icon-pack="feather" icon="icon-user-check" v-model="formData.registrationNumber" />
            <span class="text-danger text-sm" v-show="errors.has('Registration Number')">{{ errors.first('Registration Number') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="formData.emailNotificationsEnabled">Receive Email Notifications</vs-checkbox>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Profile Picture</vs-divider>
        <div class="vx-col xl:w-1/6 mx-auto pt-2 self-center">
          <img sizes="100px" v-bind:src="formData.uploadedFileName" v-show="formData.uploadedFileName" @click="showUpload" width="100%" class="cursor-pointer">
          <div class="flex flex-wrap items-center justify-center pb-4">
            <v-uploader @done="successUpload" v-show="!formData.uploadedFileName" ref="fileUpload" file-type-exts="jpeg,jpg,png" button-text="Upload Image" language="en" file-size-limit="10MB" :preview="false"></v-uploader>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Signature</vs-divider>
        <div class="vx-col cropper-div">
          <input
            ref="input"
            type="file"
            name="image"
            accept="image/*"
            @change="setImage"
          />
          <section class="cropper-area_tool">
            <div class="img-cropper">
              <vue-cropper
                v-show="formData.signatureImageUrl"
                ref="cropper"
                :src="formData.signatureImageUrl"
                preview=".preview"
              />
            </div>
          </section>
          <div class="vx-vol cropper-area_buttons">
            <div class="vx-row ml-0">
              <vs-button class="mr-5 mt-3 new-signature-button-on-select" color="success" type="filled" icon-pack="feather" icon="icon-upload" @click.prevent="showFileChooser">Upload New Signature</vs-button>

              <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" type="border" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click.prevent="reset">Reset</vs-button>

              <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-zoom-in" @click.prevent="zoom(0.2)" />
              <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-zoom-out" @click.prevent="zoom(-0.2)" />

              <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-left" @click.prevent="move(-10, 0)" />
              <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-right" @click.prevent="move(10, 0)" />
              <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-up" @click.prevent="move(0, -10)" />
              <vs-button v-show="newSignatureClicked" radius type="border" class="mr-5 mt-3" icon-pack="feather" icon="icon-arrow-down" @click.prevent="move(0, 10)" />

              <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-rotate-cw" @click.prevent="rotate(90)" />
              <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-rotate-ccw" @click.prevent="rotate(-90)" />

              <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" color="success" icon-pack="feather" icon="icon-crop" @click.prevent="cropImage">Crop</vs-button>
            </div>
          </div>
          <p v-show="cropImg" class="mt-3 text-success">Signature cropped. Remember to click <strong>Save</strong>.</p>
        </div>
        <div v-show="canChangePassword">
          <vs-divider class="mb-6 pt-0">Login Credentials</vs-divider>
          <div class="vx-row pb-3" v-show="!isChangePasswordHidden">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-checkbox v-model="changePassword">Change Password</vs-checkbox>
            </div>
          </div>
          <div class="vx-row pb-3" v-show="changePassword">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input style="display: none;"/>
              <label>Password</label>
              <div style="display: flex;">
                <vs-input id="passBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100'" name="password" ref="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.password" />
                <feather-icon @mouseover="showPassword('passBox')" @mouseout="hidePassword('passBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
          </div>
          <div class="vx-row pb-3" v-show="changePassword">
            <div class="vx-col sm:w-1/2 w-full mb-2" v-show="formData.password" >
              <label>Confirm Password</label>
              <div style="display: flex;">
                <vs-input id="confPassBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100|confirmed:password'" name="confirm_password" data-vv-as="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.passwordConfirm" />
                <feather-icon @mouseover="showPassword('confPassBox')" @mouseout="hidePassword('confPassBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
            </div>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Roles</vs-divider>
        <div class="vx-row pb-3" :key="index" v-for="(role,index) in formData.roles">
          <div class="vx-col mb-2">
            <vx-tooltip delay=".5s" position="right" :text="role.permissionText">
              <!-- <vs-checkbox :value="role.isSelected" v-model="role.isSelected" :style="{ 'display': (role.text == 'Teacher') && $siteTypeId() != 1 ? 'none' : 'flex' }">{{role.text}}</vs-checkbox> -->
              <vs-checkbox :disabled="role.id == 19 ? false: monitorSelected" :value="role.isSelected" @click="role.id == 19 ? isMonitorChecked(role) : ()=>{}"  v-model="role.isSelected">{{role.text}}</vs-checkbox>
            </vx-tooltip>
          </div>
        </div>

        <vs-divider class="mb-6 pt-0"></vs-divider>
        
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditUser" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" class="mr-3 mb-2 vs-con-loading__container" v-if="formData.id" @click="deleteUserFromSite" ref="deleteUserButton">Delete</vs-button>
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#userInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
  export default {
    data() {
      return {
        pageSize: 10,
        loadingColor:'#fff',
        selected: [],
        isInfoHidden: true,
        isUserListHidden: false,
        isChangePasswordHidden: false,
        users: [],
        sites: [],
        formData: {
          id: 0,
          userFirstName: "",
          userLastName: "",
          work: "",
          mobile: "",
          email: "",
          password: "",
          passwordConfirm: "",
          isActive: false,
          roles: [],
          site: [],
          uploadedFileName: "",
          idNumber: "",
          registrationNumber: "",
          signatureImageUrl: "",
          emailNotificationsEnabled: false
        },
        changePassword: false,
        showInactive: false,
        existingUser: [],
        mode: "",
        currentSite: "",
        canChangePassword: false,
        currentUser: {},
        isLoading: false,
        allowRegNum: false,
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false
        },
        cropImg: null,
        newSignatureClicked: false,
        monitorSelected:false,
      }
    },
    components: { 
      VueCropper
    },
    computed: {
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
      
    },
    watch: {
      showInactive: function(val) {
        this.criteria.showInactive = val;
        this.loadUserData();
      },
      formData: {
        deep: true,
        handler() {
          var self = this;
          if(self.formData.roles.filter(function(item) { return item.isSelected && (item.text == "Assessor" || item.text == "Moderator") }).length > 0){
            self.allowRegNum = true;
          }else{
            self.allowRegNum = false;
          }
        }
      },
    },
    methods: {
      evaluateUser() {
        var self = this;
        if(this.mode == "Add User"){
          self.$validator.validate('email').then(result => {
            if (result) {
              var onSuccess = response => {
                self.existingUser = response.data;
                if (self.existingUser != null){
                  self.openConfirm();
                }
              };
              self.formData.email = self.formData.email.toLowerCase();
              
              self.$ajaxGet(self, "user/evaluateUser/" + self.formData.email, onSuccess);
            }
          });
        }
      },
      initValues() {
        this.formData.id = 0;
        this.formData.userFirstName = "";
        this.formData.userLastName = "";
        this.formData.work = "";
        this.formData.mobile = "";
        this.formData.email = "";
        this.formData.password = "";
        this.formData.passwordConfirm = "";
        this.formData.isActive = true;
        this.formData.uploadedFileName = "";
        this.formData.idNumber = "";
        this.formData.registrationNumber = "";
        this.formData.signatureImageUrl = "";
        this.formData.emailNotificationsEnabled = false;
        this.isLoading = false;
        this.mode = "";
        this.cropImg = null;
        this.newSignatureClicked = false;
        this.errors.clear();
        this.monitorSelected = false;
      },
      deleteUserFromSite(){
        var self = this;
        self.showLoadingOnDeleteButton();
        var onSuccess = response => 
        {
          self.$vs.notify({
            title:'Information',
            color: "warning",
            text: "User Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });

          self.isInfoHidden = true;
          self.loadUserData();
          self.isUserListHidden = false;
        }
        var onFinally = response => 
        {
          self.$vs.loading.close(self.$refs.deleteUserButton.$el);
        }
        self.$ajaxGet(self, `User/RemoveUserFromSite?siteId=${self.formData.site.siteId}&userId=${self.formData.id}`, onSuccess, onFinally)
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteUserButton.$el,
          scale: 0.45
        });
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
        this.isUserListHidden = false;
        this.changePassword = false;
      },
      addNewUser() {
        this.initValues();
        this.canChangePassword = true;
        this.isChangePasswordHidden = true;
        this.isUserListHidden = true;
        this.isInfoHidden = false;
        this.showLoadingOnAddNewCard();
        this.getRoles();
        this.mode = "Add User";
        this.changePassword = true;
      },
      showPassword(elementId) {
        document.getElementById(elementId).removeAttribute("type");
      },
      hidePassword(elementId) {
        document.getElementById(elementId).setAttribute("type", "password");
      },
      saveData() {
        this.loadUserData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      getRoles() {
        const self = this;        
        var onSuccess = function (response) {
          self.formData.roles = response.data;
          if(self.$siteTypeId() != 1){
            self.formData.roles = self.formData.roles.filter(function(item) {return item.id != 14 && item.id != 15 && item.id != 20});
          } 
          if(self.$getSiteId() != 31){
            self.formData.roles = self.formData.roles.filter(function(item) {return item.id != 18});
          }
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.userInfo.$el);
        };
        self.$ajaxGet(self, "role/listroles", onSuccess, onFinally);
      },
      loadUserData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.users = [];

          if(self.criteria.pageNumber > 1)
            self.users[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};
          
          self.users = self.users.concat(response.data.records);
          
          if(response.data.count > (self.criteria.pageNumber * self.pageSize))
            self.users[response.data.count - 1] = {};
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.usersTable.$el);
        };

        self.$ajaxPost(self, "User/GetUsersSst", self.criteria, onSuccess, onFinally);
      },
      getCurrentUser() {
        var self = this;
        var onSuccess = function (response) {
          self.currentUser = response.data;
        };
        self.$ajaxGet(self, "user/GetCurrentUserInfo", onSuccess);
      },
      handleSelectedUser(user) {
        this.mode = "Edit User";
        this.canChangePassword = this.currentUser.isSiteAdmin ? true : false;
        this.isChangePasswordHidden = false;
        this.isUserListHidden = true;
        this.isInfoHidden = false;
        this.changePassword = false;
        this.formData.id = user.id;
        this.formData.userFirstName = user.userFirstName;
        this.formData.userLastName = user.userLastName;
        this.formData.work = user.work;
        this.formData.mobile = user.mobile;
        this.formData.uploadedFileName = user.imageUrl;
        this.formData.email = user.email;
        this.formData.password = user.password;
        this.formData.passwordConfirm = user.password;
        this.formData.isActive = user.isActive;
        this.formData.idNumber = user.idNumber;
        this.formData.registrationNumber = user.registrationNumber;
        if (this.$siteTypeId() == 1) {
          this.formData.roles = user.roles;
        }
        else {
          this.formData.roles = user.roles.filter(function(item) {return item.id != 14 && item.id != 15 && item.id != 18});
        }
        this.formData.signatureImageUrl = user.signatureImageUrl;
        this.formData.emailNotificationsEnabled = user.emailNotificationsEnabled;

        if(JSON.parse(localStorage.getItem('userSiteInfo'))[0]){
          this.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
        }else{
          this.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'));
        }
        var monitorSelected = this.formData.roles.filter(x=>x.id == 19);
        if(monitorSelected && monitorSelected[0].isSelected){
          this.monitorSelected = true;
        }
      },
      saveEditUser() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnSaveButton();
            self.formData.email = self.formData.email.toLowerCase();

            var onSuccess = response => {
              self.saveData();
              self.isInfoHidden = true;
              self.scrollToNavbar('navbarGlobal');
              self.isUserListHidden = false;
              self.cropImg = null;
              self.newSignatureClicked = false;
              self.$refs.cropper.destroy();
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "User Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            
            self.$ajaxPost(self, "user/addedituser", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      successUpload(data) {
        this.formData.uploadedFileName = data[0].url;
        this.$vs.loading.close(this.$refs.fileUpload.$el);
		    this.isLoading = false;
      },
      showUpload() {
        this.formData.uploadedFileName = null;
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnAddNewCard(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.userInfo.$el,
          scale: 1
        });
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.usersTable.$el,
          scale: 1
        });
      },
      showLoadingOnUploader(){
        var self = this;
        self.isLoading = true;
        self.$vs.loading({
          type: "material",
          container: self.$refs.fileUpload.$el,
          scale: 0.45
        });
      },
      scrollToNavbar(elementId) {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
      },
      openConfirm() {
        var self = this;
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name
        else
          self.currentSite = JSON.parse(localStorage.getItem('userSiteInfo')).name
        
        var sites = self.existingUser.sites.map((item) => {return item.name});
        self.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: `Email Already Exists`,
          text: 'The email address (' + self.existingUser.email + ') seems to\nalready exist for \'' + self.existingUser.displayName + '\' at the following site(s):\n' + sites.join('\n') + '.\n\nBy choosing \'Accept\', you\'ll allow \'' + self.existingUser.displayName + '\' to gain access to your current site: ' + self.currentSite + '.',
          accept: self.acceptAlert
        })
      },
      acceptAlert() {
        const self = this;
        var user = [];
        self.showLoadingOnAddNewCard();

        var onSuccess = function (response) {
          user = response.data;
          self.changePassword = false;
          self.formData.id = user.id;
          self.formData.userFirstName = user.userFirstName;
          self.formData.userLastName = user.userLastName;
          self.formData.work = user.work;
          self.formData.mobile = user.mobile;
          self.formData.email = user.email;
          self.formData.password = user.password;
          self.formData.passwordConfirm = user.password;
          self.formData.isActive = user.isActive;
          self.formData.idNumber = user.idNumber;
          self.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.userInfo.$el);
        };

        self.$ajaxGet(self, "user/LinkExistingUserToNewSite/" + self.existingUser.userId, onSuccess, onFinally);
      },
      handleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.criteria.searchPhrase = searchPhrase;
          self.criteria.showInactive = self.showInactive;

          self.loadUserData();
        }
        else if (searchPhrase == ""){
          self.criteria.searchPhrase = searchPhrase;
          self.loadUserData();
        }
      },
      handleChangePage(pageNumber) {
        var self = this;

        if(pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;
          self.criteria.showInactive = self.showInactive;

          self.loadUserData();
        }
      },
      handleSort(sortKey, sortOrder) {
        var self = this;

        self.criteria.sortKey = sortKey;
        self.criteria.sortOrder = sortOrder;
        self.criteria.showInactive = self.showInactive;

        self.loadUserData();
      },
      cropImage() {
        var self = this;
        self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

        var fileExt = self.cropImg.substring(
          self.cropImg.indexOf("/") + 1, 
          self.cropImg.indexOf(";")
        );



        var byteString = atob(self.cropImg.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ab], { type: 'image/' + fileExt });


        
        var data = new FormData();
        data.append('image', blob, "signature_" + self.formData.id + "." + fileExt);

        var onSuccess = response => {
          self.formData.signatureImageUrl = response.data.url;
        };

        self.$ajaxPost(self, "tempupload", data, onSuccess);
      },
      move(offsetX, offsetY) {
        this.$refs.cropper.move(offsetX, offsetY);
      },
      reset() {
        this.cropImg = null;
        this.$refs.cropper.reset();
      },
      rotate(deg) {
        this.$refs.cropper.rotate(deg);
      },
      setImage(e) {
        const file = e.target.files[0];
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.formData.signatureImageUrl = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
          this.newSignatureClicked = true;
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      showFileChooser() {
        this.$refs.input.click();
      },
      zoom(percent) {
        this.$refs.cropper.relativeZoom(percent);
      },
      isMonitorChecked(val){
        if(val.isSelected){
          this.monitorSelected = false;
        }
        if(!val.isSelected){
          this.monitorSelected = true;
          this.formData.roles = this.formData.roles.map(element => {
            if(element.id != 19){
              element.isSelected = false;
            }
            return element;
          })
        }
      }
    },
    mounted() {
      var self = this;
      self.showLoadingOnTable();
      self.getCurrentUser();
      
      self.$refs.fileUpload.$el.addEventListener("click", function(){
        if(!self.isLoading)
          self.showLoadingOnUploader();
        else{
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.fileUpload.$el);
        }
      });

      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.usersTable.currentPage;

      self.loadUserData();

      window.addEventListener('resize', () => {
        self.reset();
      });
    },
  }

</script>
<style lang="scss">

.new-signature-button-on-select{
  height: fit-content;
  margin-top: 14px;
  margin-right: 2px;
}

.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
  }
  .cropper-area_tool {
    width: 60%;
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
  // .actions vs-button {
    
  //   padding: 5px 15px;
  //   background: #0062CC;
  //   color: white;
  //   text-decoration: none;
  //   border-radius: 3px;
  //   margin-right: 1rem;
  //   margin-bottom: 1rem;
  // }
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
</style>